require('bootpag/lib/jquery.bootpag.min');
require('jquery-deparam/jquery-deparam');

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var utils = new CommonUtils();

var Pager = Marionette.View.extend({
    template: require('../../templates/pager/pager.html'),

    model: new Backbone.Model(),

    ui: {
        pagerContent: '#pager-content',
        pageSize: '#page-size'
    },

    events: {
        'change @ui.pageSize': 'onPageSizeChanged'
    },

    templateContext: function () {
        return {
            pageSize: Constants.pageCapacity
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'renderPager');
        var that = this;
        this.items = [];
        this.params = [];
        if (options) {
            this.baseCountUrl = options.baseCountUrl;
            this.pagesToDisplay = options.pagesToDisplay;
            this.callbackFunctions = options.callbackFunctions;
        }
        this.pagesToDisplay = this.pagesToDisplay || 10;
        this.baseCountUrl = this.baseCountUrl || '/api/dbo/count';

        var paramsTokens = window.location.hash.split("?");
        if (paramsTokens.length > 1) {
            if (this.baseCountUrl.indexOf("?") > 0)
                this.baseCountUrl += "&" + paramsTokens[1];
            else
                this.baseCountUrl += "?" + paramsTokens[1];
        }

        this.params = utils.getDefaultListParams();
        this.baseHash = utils.getCleanBaseHash();

        $.ajax({
            type: "GET",
            url: this.baseCountUrl,
            statusCode: {
                200: function (response) {
                    that.calculateAttributes(response);
                    that.renderPager();
                    that.triggerMethod('pager:count:change', response);

                    if (response == 0) {
                        that.hidePageSize()
                    }
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    },

    calculateAttributes: function (count) {
        this.total = count / this.params['page-size'] | 0;
        if (count % this.params['page-size'] > 0) {
            this.total++;
        }
    },

    renderPager: function () {
        var that = this;
        $(this.ui.pagerContent).bootpag({
            total: this.total,
            maxVisible: this.pagesToDisplay,
            page: this.params.page + 1,
            firstLastUse: true,
            first: 'FIRST',
            last: 'LAST'
        }).on("page", function (event, num) {

            if (that.callbackFunctions && _.isFunction(that.callbackFunctions.signDocuments)) {
                that.callbackFunctions.signDocuments(function() {
                    that.params.page = num - 1;
                    window.location.hash = that.baseHash + "?" + utils.objectToQueryParams(that.params)
                    that.renderPager();
                });
            } else {
                that.params.page = num - 1;
                window.location.hash = that.baseHash + "?" + utils.objectToQueryParams(that.params)
            }
        });
    },

    onPageSizeChanged: function(event) {
        var val = event.target.value
        Constants.pageCapacity = val
        this.params["page-size"] = val
        this.params["page"] = 0;
        window.location.hash = this.baseHash + "?" + utils.objectToQueryParams(this.params)
    },

    hidePageSize: function() {
        this.ui.pageSize.remove()
    }

});

module.exports = Pager;


//////////////////
// WEBPACK FOOTER
// ./app/views/pager/pager-view.js
// module id = 309
// module chunks = 0